namespace Areas.OneTimeUploads {
    "use strict";

    export function showCollaborationAreaLookup() {
        const collaborationAreaLookupDialog =
            new Areas.Dialogs.CollaborationAreaLookup.CollaborationAreaLookupDialog(collaborationAreaLookupDialogClosing);
    }

    function collaborationAreaLookupDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const CollaborationAreaId = data.collaborationAreaId;
        const newName = data.name;
        const projectName = data.projectName;
        const projectNumber = data.projectNumber;

        //this is the lookup form _CollaborationAreaLookupForm
        const lookupForm: DevExpress.ui.dxForm = Areas.getForm("FTPCollaborationAreaLookupForm");
        const lookupData: any = lookupForm.option('formData');

        lookupData.Name = newName;
        lookupData.ProjectName = projectName;
        lookupData.ProjectNumber = projectNumber;

        const lunumberControl: DevExpress.ui.dxTextBox = lookupForm
            .getEditor('ProjectNumber') as DevExpress.ui.dxTextBox;
        lunumberControl.option("value", projectNumber);

        const lunameControl: DevExpress.ui.dxTextBox = lookupForm
            .getEditor('ProjectName') as DevExpress.ui.dxTextBox;
        lunameControl.option("value", projectName);

        const luareaControl: DevExpress.ui.dxTextBox = lookupForm
            .getEditor('CollaborationAreaName') as DevExpress.ui.dxTextBox;
        luareaControl.option("value", newName);

        //this is the main form _DataForm.cshtml
        const dataForm: DevExpress.ui.dxForm = Areas.getForm("OneTimeUploadForm");
        const newData: any = dataForm.option('formData');

        newData.CollaborationAreaId = CollaborationAreaId;
    }
}